import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { Component, ElementRef, Injector, Type } from "@angular/core";
import { InterventionDataPrimaryLookupService } from "shared/cubiq-services";
import * as Service from "./services/bfx-intervention-contextmenu.service";
import { BfxBaseBlotterContextMenu } from "../bfx-base-blotter/bfx-base-blotter-contextmenu";
import { trigger, state, animate, transition, style } from "@angular/animations";
const LINE_HEIGHT: number = 30;
import { LoggerService } from "@bfx/logger";
import { BfxInterventionContextMenuItem } from "app/bfx-blotter-intervention/models/bfx-intervention-contextmenu.models";
const logger = LoggerService.for(__dirname);

@Component({
  selector: "bfx-intervention-context-menu",
  templateUrl: "./html/bfx-intervention-contextmenu.html",
  animations: [
    trigger("showHideMenu", [
      state("show", style({ opacity: 1 })),
      state("hide", style({ opacity: 0 })),
      transition("show => hide", animate("100ms ease-in")),
      transition("hide => show", animate("100ms ease-out")),
    ]),
  ],
  styleUrls: ["../bfx-base-blotter/bfx-base-blotter-contextmenu.less"],
  standalone: false,
})
export class BfxInterventionContextMenuComponent extends BfxBaseBlotterContextMenu<CubiqTS.InterventionEventImpl> {
  constructor(
    injector: Injector,
    lookupService: InterventionDataPrimaryLookupService,
    elementRef: ElementRef,
  ) {
    super(injector, lookupService, elementRef);
  }

  protected getMenuServiceType(): Type<Service.BfxInterventionContextMenuService> {
    return Service.BfxInterventionContextMenuService;
  }

  // TODO: move to base and refactor others
  public isItemEnabled(item: BfxInterventionContextMenuItem) {
    if (item == null) {
      return false;
    }
    return item.state.enabled;
  }

  public selectedMenuItem(item: BfxInterventionContextMenuItem, event?: any) {
    if (this.isItemEnabled(item)) {
      (this.menuService as Service.BfxInterventionContextMenuService).fireActionEvent(
        item.actionId,
        this.currentLadderBlotter,
        null,
        null,
        item.state,
        event,
      );
      if (item.clearSelection) {
        this.currentLadderBlotter?.gridOptions?.api?.deselectAll();
        this.currentLadderBlotter?.onSelectionChanged([]);
      }
      this.hideMenu();
    }
  }
}
